/* eslint-disable */
import { createStyles, WithStyles, withStyles } from "@material-ui/styles";
import { Theme, Divider } from "@material-ui/core";
import * as React from "react";

import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import Layout from "../layouts/Layout";
import { BackButton } from "../modules/basf-ui";
import { HierarchicalSlides, Slide } from "../modules/slides/components/HierarchicalSlides";
import {
  GlobalCategory,
  GlobalCategoryTitle,
  GlobalCategoryBody,
  GlobalCategoryRow,
} from "../modules/slides/components/HierarchicalSlides";
import { Category, CategoryBody, CategoryTitle } from "../modules/slides/components/HierarchicalSlides";
import { Subcategory, SubcategoryBody, SubcategoryTitle } from "../modules/slides/components/HierarchicalSlides";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "row",
      overflow: "hidden",
      maxHeight: "100vh",
    },
    content: {
      background: "rgba(242, 245, 243, 0.5)", // todo: надо новый тип темы, в него добавить конфиг фонов
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(6),
      width: "100%",
      boxSizing: "border-box",
      overflow: "auto",
      // maxHeight: `calc(100vh + ${theme.spacing(8 + 6)})`,
    },
    toolsContainer: {
      display: "fixed",
      paddingTop: theme.spacing(13.25),
      paddingLeft: theme.spacing(2),
    },
  });

type Props = WithStyles<typeof styles>;

class SlidesPage extends React.Component<Props> {
  render() {
    const { classes } = this.props;
    return (
      <Layout>
        <Header />
        <div className={classes.root}>
          <div className={classes.toolsContainer}>
            <BackButton />
          </div>
          <div className={classes.content}>
            <HierarchicalSlides>
              <GlobalCategory expanded>
                <GlobalCategoryTitle> Global unit</GlobalCategoryTitle>
                <GlobalCategoryBody>
                  <GlobalCategoryRow>
                    <Category expanded>
                      <CategoryTitle>
                        Reports for AP lead crops and countries including crop area, production, <br />
                        net trade, self sufficiency, consumption per capita and population
                      </CategoryTitle>
                      <CategoryBody>
                        <Subcategory expansionKey={"1"}>
                          <SubcategoryTitle>Historical development</SubcategoryTitle>
                          <SubcategoryBody>
                            <Slide number={1} to="/slides/world-overview-major-crops">
                              World overview for major crops (crop area, production, yield, net trade)
                            </Slide>
                            <Slide number={2} to="/slides/lead-countries-major-crops">
                              Lead countries for major crops (crop area, production, yield)
                            </Slide>
                            <Slide number={3} to="/slides/aquarium-area">
                              Aquarium chart: AP Major crops by lead country - Area
                            </Slide>
                            <Slide number={4} to="/slides/aquarium-production">
                              Aquarium chart: AP Major crops by lead country - Production
                            </Slide>
                            <Slide number={7} to="/slides/aquarium-crop-value">
                              Aquarium chart: AP Major crops by lead country - Crop value
                            </Slide>
                            <Slide number={25} to="/slides/lead-countries-major-crops-population">
                              Lead countries for major crops (population, self sufficiency, consumption per capita)
                            </Slide>
                          </SubcategoryBody>
                        </Subcategory>
                        <Subcategory expansionKey={"2"}>
                          <SubcategoryTitle>Forecast</SubcategoryTitle>
                          <SubcategoryBody>
                            <Slide number={5} to="/slides/world-overview-major-crops-forecast">
                              World overview for major crops incl. forecast (crop area, production, yield, net trade)
                            </Slide>
                            <Slide number={6} to="/slides/lead-countries-major-crops-forecast">
                              Lead countries for major crops incl. forecast (crop area, production, yield)
                            </Slide>
                            <Slide number={26} to="/slides/lead-countries-major-crops-population-forecast">
                              Lead countries for major crops incl. forecast (population, self sufficiency, consumption
                              per capita)
                            </Slide>
                          </SubcategoryBody>
                        </Subcategory>
                      </CategoryBody>
                    </Category>
                    <Category expanded>
                      <CategoryTitle>
                        Comparsion reports showing year to year deviation (in %) <br />
                        including crop area and production
                      </CategoryTitle>
                      <CategoryBody>
                        <Subcategory expansionKey={"3"}>
                          <SubcategoryTitle>Annual historical development in %</SubcategoryTitle>
                          <SubcategoryBody>
                            <Slide number={8} to="/slides/annual-crop-area">
                              World overview – annual crop area development for AP lead crops (w/o F&V)
                            </Slide>
                            <Slide number={9} to="/slides/annual-crop-production">
                              World overview – annual crop production development for AP lead crops (w/o F&V)
                            </Slide>
                            <Slide number={10} to="/slides/ap-annual-area">
                              AP lead crops by lead countries – annual area development
                            </Slide>
                            <Slide number={11} to="/slides/ap-annual-production">
                              AP lead crops by lead countries – annual production development
                            </Slide>
                          </SubcategoryBody>
                        </Subcategory>
                      </CategoryBody>
                    </Category>
                  </GlobalCategoryRow>
                  <GlobalCategoryRow>
                    <Category expanded>
                      <CategoryTitle>Price reports for crop commodities and fertilizers</CategoryTitle>
                      <CategoryBody>
                        <Subcategory expansionKey={"4"}>
                          <SubcategoryTitle>Historical development</SubcategoryTitle>
                          <SubcategoryBody>
                            <Slide number={12} to="/slides/slide-12">
                              Weekly crop commodity prices – overview current vs year ago
                            </Slide>
                            <Slide number={13} to="/slides/slide-13">
                              Weekly crop commodity price development incl. ending stocks, stock-to-use ratio
                            </Slide>
                            <Slide number={14} to="/slides/stocks">
                              Stocks to use-ratio vs crop price index
                            </Slide>
                            <Slide number={15} to="/slides/slide-15">
                              Crop commodity price summary – absolute values and index
                            </Slide>
                            <Slide number={16} to="/slides/slide-16">
                              USD and EUR price development index incl. crude oil
                            </Slide>
                            <Slide number={17} to="/slides/slide-17">
                              Weekly fertilizer prices – overview current vs year ago
                            </Slide>
                            <Slide number={18} to="/slides/slide-18">
                              Weekly fertilizer price development
                            </Slide>
                            <Slide number={20} to="/slides/slide-20">
                              Crop commodity price index by crop vs. gold/crude oil/DAX/S&P 500
                            </Slide>
                            <Slide number={21} to="/slides/slide-21">
                              Crop price index
                            </Slide>
                            <Slide number={23} to="/slides/slide-23">
                              Correlation crude oil and crop
                            </Slide>
                            <Slide number={24} to="/slides/slide-24">
                              Fruits prices by lead countries
                            </Slide>
                            <Slide number={31} to="/slides/slide-31">
                              Crop commodity prices - historical vs. short term forecast
                            </Slide>
                            <Slide number={32} to="/slides/slide-32">
                              Crop commodity prices - historical vs. long term forecast
                            </Slide>
                            <Slide number={33} to="/slides/slide-33">
                              Key commodities prices dynamics
                            </Slide>
                            <Slide number={34} to="/slides/slide-34">
                              CBOT forward curve
                            </Slide>
                            <Slide number={35} to="/slides/slide-35">
                              Monthly commodity prices
                            </Slide>
                            <Slide number={36} to="/slides/slide-36">
                              Weekly commodity prices
                            </Slide>
                          </SubcategoryBody>
                        </Subcategory>
                      </CategoryBody>
                    </Category>
                    <Category>
                      <CategoryTitle>Meat reports on beef & veal, pork and broiler</CategoryTitle>
                    </Category>
                  </GlobalCategoryRow>
                </GlobalCategoryBody>
              </GlobalCategory>
              <Divider />
              <GlobalCategory expanded>
                <GlobalCategoryTitle>APE unit</GlobalCategoryTitle>
                <GlobalCategoryBody>
                  <GlobalCategoryRow>
                    <Category expanded>
                      <CategoryTitle>
                        Reports for APE lead crops and countries including crop area, production, <br />
                        net trade, self sufficiency, consumption per capita and population
                      </CategoryTitle>
                      <CategoryBody>
                        <Subcategory expansionKey={"5"}>
                          <SubcategoryTitle>Historical development</SubcategoryTitle>
                          <SubcategoryBody>
                            <Slide number={1} to="/slides/world-overview-major-crops-ape">
                              APE overview for major crops (crop area, production, yield, net trade)
                            </Slide>
                            <Slide number={2} to="/slides/lead-countries-major-crops-ape">
                              Lead countries for major crops (crop area, production, yield)
                            </Slide>
                            <Slide number={3} to="/slides/aquarium-area-ape">
                              Aquarium chart: APE Major crops by lead country - Area
                            </Slide>
                            <Slide number={4} to="/slides/aquarium-production-ape">
                              Aquarium chart: APE Major crops by lead country - Production
                            </Slide>
                          </SubcategoryBody>
                        </Subcategory>
                        <Subcategory expansionKey={"6"}>
                          <SubcategoryTitle>Forecast</SubcategoryTitle>
                          <SubcategoryBody>
                            <Slide number={5} to="/slides/world-overview-major-crops-forecast-ape">
                              APE overview for major crops incl. forecast (crop area, production, yield, net trade)
                            </Slide>
                            <Slide number={6} to="/slides/lead-countries-major-crops-forecast-ape">
                              Lead countries for major crops incl. forecast (crop area, production, yield)
                            </Slide>
                          </SubcategoryBody>
                        </Subcategory>
                      </CategoryBody>
                    </Category>
                    <Category expanded>
                      <CategoryTitle>
                        Comparsion reports showing year to year deviation (in %) <br />
                        including crop area and production
                      </CategoryTitle>
                      <CategoryBody>
                        <Subcategory expansionKey={"7"}>
                          <SubcategoryTitle>Annual historical development in %</SubcategoryTitle>
                          <SubcategoryBody>
                            <Slide number={8} to="/slides/annual-crop-area-ape">
                              World overview – annual crop area development for APE lead crops (w/o F&V)
                            </Slide>
                            <Slide number={9} to="/slides/annual-crop-production-ape">
                              World overview – annual crop production development for APE lead crops (w/o F&V)
                            </Slide>
                            <Slide number={10} to="/slides/ap-annual-area-ape">
                              APE lead crops by lead countries – annual area development
                            </Slide>
                            <Slide number={11} to="/slides/ap-annual-production-ape">
                              APE lead crops by lead countries – annual production development
                            </Slide>
                          </SubcategoryBody>
                        </Subcategory>
                      </CategoryBody>
                    </Category>
                  </GlobalCategoryRow>
                  <GlobalCategoryRow>
                    <Category expanded>
                      <CategoryTitle>Price reports for crop commodities and fertilizers</CategoryTitle>
                      <CategoryBody>
                        <Subcategory expansionKey={"8"}>
                          <SubcategoryTitle>Historical development</SubcategoryTitle>
                          <SubcategoryBody>
                            <Slide number={24} to="/slides/slide-24-ape">
                              Fruits prices by lead countries
                            </Slide>
                          </SubcategoryBody>
                        </Subcategory>
                      </CategoryBody>
                    </Category>
                  </GlobalCategoryRow>
                </GlobalCategoryBody>
              </GlobalCategory>
              <Divider />
            </HierarchicalSlides>
          </div>
        </div>
        <Footer />
      </Layout>
    );
  }
}

export default withStyles(styles)(SlidesPage);
